import { User as FirebaseUser } from 'firebase/auth';
import { FirebaseIdentity, User, UserProfile } from './types';

export const mapFirebaseUserToUser = (
  firebaseUser: FirebaseUser
): FirebaseIdentity => {
  return {
    id: firebaseUser.uid,
    uid: firebaseUser.uid,
    name:
      firebaseUser.displayName || firebaseUser.email?.split('@')[0] || 'User',
    email: firebaseUser.email,
    displayName: firebaseUser.displayName,
    photoURL: firebaseUser.photoURL,
    emailVerified: firebaseUser.emailVerified,
    providerId: firebaseUser.providerData[0]?.providerId,
    createdAt: firebaseUser.metadata.creationTime,
    lastLoginAt: firebaseUser.metadata.lastSignInTime,
  };
};

export const createDefaultUserProfile = (user: User): UserProfile => {
  return {
    uid: user.uid,
    email: user.email || undefined,
    displayName: user.displayName || undefined,
    preferences: {
      theme: 'light',
      language: 'en',
      notifications: {
        email: true,
        push: true,
        sms: false,
      },
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  return password.length >= 6;
};

export const getInitials = (name: string | null | undefined): string => {
  if (!name) return '';
  return name
    .split(' ')
    .map(part => part.charAt(0).toUpperCase())
    .join('')
    .substring(0, 2);
};

export const getDisplayName = (user: User | UserProfile): string => {
  if (user.displayName) return user.displayName;
  if ('firstName' in user && 'lastName' in user) {
    return [user.firstName, user.lastName].filter(Boolean).join(' ');
  }
  return user.email?.split('@')[0] || 'User';
};
